<mat-form-field class="full-width">
  <mat-label ssFormLabel></mat-label>

  <mat-select   [compareWith]="compareWith" 
                [value]="valueSubject | async"
  >
    <mat-select-trigger *ngIf="selectedItemSubject | async">
      <ng-container [ngSwitch]="matTemplateTypeObs | async">

        <ss-template-select-trigger
          *ngSwitchCase="'fromTemplate'"
        ></ss-template-select-trigger>

        <ng-container *ngSwitchCase="'basic'">{{
          displayObs | async | translate
        }}</ng-container>
      </ng-container>
    </mat-select-trigger>

    <ng-container *ngIf="(dataObs | async)?.length">
      <mat-option
        class="padding-standard"
        *ngFor="let item of dataObs | async"
        [ngStyle]="{
          height:
            (matTemplateTypeObs | async) === 'fromTemplate'
              ? 'fit-content'
              : undefined
        }"
        [value]="item"
      >
        <ss-mat-option-template [item]="item"></ss-mat-option-template>
      </mat-option>
    </ng-container>

    <ng-container *ngIf="dataSourceSubject | async">
      <mat-option
        class="padding-standard"
        *ngFor="let item of fetchedDataSubject | async"
        [value]="getValueExpr(item)"
      >
        <ss-mat-option-template [item]="item"></ss-mat-option-template>
      </mat-option>
    </ng-container>
  </mat-select>

  <mat-error ssFormValidationMessage></mat-error>
  <mat-hint *ngIf="hintObs | async">{{ hintObs | async }}</mat-hint>
</mat-form-field>
